import { setService, setProject } from './index';
import { SendServiceSubscribe, SendProjectSubscribe, SendAction } from '../../socket/socket';

export const onUpdateService = (sid) => async (dispatch, getstate) => {
  if (getstate().app.sprogress) {
    SendServiceSubscribe(sid, getstate().app.serviceId);
    dispatch(setService(sid));
  }
};
export const onUpdateProject = (pid) => async (dispatch, getstate) => {
  if (getstate().app.sprogress) {
    SendProjectSubscribe(pid, getstate().app.projectId);
    dispatch(setProject(pid));
  }
};
export const onAction = (payload) => {
  SendAction(payload);
};
